import React from 'react'

import { ActivityHistoryTypeEnum } from '../activityHistoryTypes'
import { Text, Flex } from 'front-end/src/components'
import ActivityNameInfo from './ActivityNameInfo'

interface ActivityHistoryCPDNameProps {
  name: string
  description?: string
  downloadLink: string
}

const ActivityHistoryCPDName = ({
  name,
  description = '',
  downloadLink
}: ActivityHistoryCPDNameProps) => {
  return (
    <ActivityNameInfo
      typename={ActivityHistoryTypeEnum.CPDManualEntryModel}
      title={name}
      downloadLink={downloadLink}
    >
      <Flex>
        <Text lineHeight="21px" wordBreak="break-all">
          {description}
        </Text>
      </Flex>
    </ActivityNameInfo>
  )
}

export default ActivityHistoryCPDName
